module.exports = __webpack_public_path__ + "static/media/vail-7.4fd83735.jpg";